module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_vm._m(1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "places-buttons"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        _vm.notifyVue('top', 'left')
      }
    }
  }, [_vm._v("Top Left")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        _vm.notifyVue('top', 'center')
      }
    }
  }, [_vm._v("Top Center")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        _vm.notifyVue('top', 'right')
      }
    }
  }, [_vm._v("Top Right")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        _vm.notifyVue('bottom', 'left')
      }
    }
  }, [_vm._v("Bottom Left")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        _vm.notifyVue('bottom', 'center')
      }
    }
  }, [_vm._v("Bottom Center")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        _vm.notifyVue('bottom', 'right')
      }
    }
  }, [_vm._v("Bottom Right")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header",
    attrs: {
      "data-background-color": "purple"
    }
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Notifications")]), _vm._v(" "), _c('p', {
    staticClass: "category"
  }, [_vm._v("Handcrafted by us with "), _c('i', {
    staticClass: "fa fa-heart heart"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h5', [_vm._v("Notifications Style")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-info"
  }, [_c('span', [_vm._v("This is a plain notification")])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-info"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', [_vm._v("This is a notification with close button.")])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-info alert-with-icon",
    attrs: {
      "data-notify": "container"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons",
    attrs: {
      "data-notify": "icon"
    }
  }, [_vm._v("add_alert")]), _vm._v(" "), _c('span', {
    attrs: {
      "data-notify": "message"
    }
  }, [_vm._v("This is a notification with close button and icon.")])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-info alert-with-icon",
    attrs: {
      "data-notify": "container"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons",
    attrs: {
      "data-notify": "icon"
    }
  }, [_vm._v("add_alert")]), _vm._v(" "), _c('span', {
    attrs: {
      "data-notify": "message"
    }
  }, [_vm._v("This is a notification with close button and icon and have many lines. You can see that the icon and the close button are always vertically aligned. This is a beautiful notification. So you don't have to worry about the style.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h5', [_vm._v("Notification states")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-info"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', [_c('b', [_vm._v(" Info - ")]), _vm._v(" This is a regular notification made with \".alert-info\"")])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-success"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', [_c('b', [_vm._v(" Success - ")]), _vm._v(" This is a regular notification made with \".alert-success\"")])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-warning"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', [_c('b', [_vm._v(" Warning - ")]), _vm._v(" This is a regular notification made with \".alert-warning\"")])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', [_c('b', [_vm._v(" Danger - ")]), _vm._v(" This is a regular notification made with \".alert-danger\"")])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-primary"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', [_c('b', [_vm._v(" Primary - ")]), _vm._v(" This is a regular notification made with \".alert-primary\"")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3 text-center"
  }, [_c('h5', [_vm._v("Notifications Places\n                "), _c('p', {
    staticClass: "category"
  }, [_vm._v("Click to view notifications")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-537a2dda!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Notifications.vue
// module id = 162
// module chunks = 2